import Pusher, { Channel } from "pusher-js";

declare global {
  interface Window {
    clientNotificationService: ClientNotificationService;
    PUSHER_CLIENT_FACTORY: () => Pusher;
    PUSHER_CLIENT_CONFIG: ClientNotificationConfig;
  }
}

export interface ClientNotificationConfig {
  app_key: string;
  cluster: string;
  authEndpoint: string;
}

class ClientNotificationService {
  private pusherInstance: Pusher;

  private pusherFactory = window.PUSHER_CLIENT_FACTORY;

  private clientConfig = window.PUSHER_CLIENT_CONFIG;

  private channels: Record<string, Channel> = {};

  bind(channel: string, event: string, callback: (message: unknown) => void): Channel {
    const subscribe = this.channels[channel] || (this.channels[channel] = this.pusher().subscribe(channel));

    return subscribe.bind(event, (data: { message: Record<string, unknown> }) => {
      callback(data.message);
    });
  }

  unbindChannel(channel: string): void {
    if (this.channels[channel]) {
      this.pusher().unsubscribe(channel);
      Reflect.deleteProperty(this.channels, channel);
    }
  }

  private pusher(): Pusher {
    if (!this.pusherInstance) {
      this.pusherInstance = this.pusherFactory ? this.pusherFactory() : this.createPusherInstance();

      const csrfToken = document.querySelector("[name=csrf-token]")?.getAttribute("content");

      if (csrfToken) {
        this.pusherInstance.config.auth = {
          headers: { "X-CSRF-Token": csrfToken },
        };
      }
    }

    return this.pusherInstance;
  }

  private createPusherInstance() {
    return new Pusher(this.clientConfig.app_key, {
      cluster: this.clientConfig.cluster,
      authEndpoint: this.clientConfig.authEndpoint,
    });
  }
}

if (!window.clientNotificationService) {
  window.clientNotificationService = new ClientNotificationService();
}

export default ClientNotificationService;
